import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  horizonReviewerPickerExtension,
  horizonScopeSummaryExtension,
  horizonTargetPickerExtension,
  horizonTargetIntentsExtension,
  horizonWorkloadPickerExtension,
} from './extensions';

export const horizonSourcePickerModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    horizonScopeSummaryExtension,
    horizonWorkloadPickerExtension,
    horizonTargetPickerExtension,
    horizonTargetIntentsExtension,
    horizonReviewerPickerExtension,
  ],
});
